


export const redirect = (path, option={}) => {
  if (!option.unload) window.onbeforeunload = null;
  if (!option.unload) window.unload = null;
  window.location.href = path;
}